module.exports = __webpack_public_path__ + "static/media/isotop_4.ea2b8baf.jpeg";